import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LaIconComponent} from './la-icon.component';
import {LaIconService} from './la-icon.service';
import {LaColorService} from '../colors/la-color.service';

export {LaIconService} from './la-icon.service';
export {LaIconComponent} from './la-icon.component';

// Export module's public API

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [LaIconComponent],
  declarations: [LaIconComponent],
  providers: [LaIconService]
})
export class LaIconModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LaIconModule,
      providers: [LaIconService, LaColorService]
    };
  }
}
